import clsx from "clsx";
import React from "react";
import PropTypes from "prop-types";
import styles from "./PasswordStrengthMeter.module.scss";
import { AUTH } from "../../constants";

const PasswordStrengthMeter = ({
  passwordScore
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.progressBar
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.progressBubble, {
      [styles.filledWeak]: passwordScore >= AUTH.PASSWORD_STRENGTH_SCORE.WEAK_PASSWORD
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.progressBubble, {
      [styles.filledAverage]: passwordScore >= AUTH.PASSWORD_STRENGTH_SCORE.AVERAGE_PASSWORD
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.progressBubble, {
      [styles.filledGood]: passwordScore >= AUTH.PASSWORD_STRENGTH_SCORE.GOOD_PASSWORD
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.progressBubble, {
      [styles.filledStrong]: passwordScore >= AUTH.PASSWORD_STRENGTH_SCORE.STRONG_PASSWORD
    })
  })), /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, AUTH.PASSWORD_STRENGTH_SCORE_LABEL[passwordScore]));
};

PasswordStrengthMeter.propTypes = {
  passwordScore: PropTypes.number
};
export default PasswordStrengthMeter;